import GeneralDialog from "./GeneralDialog";
import {TextField} from "@mui/material";
import React, {useRef, useState} from "react";
import Utility from "../../Utility";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";

export const CreatChecklistDialog  = observer(() => {
    const {modalStore, generalStore} = useStores();
    const [checklistTitle, setChecklistTitle] = useState('');
    const inputRef = useRef(null);

    function onEnter() {
        setChecklistTitle('');
        Utility.sleep(200).then(() => inputRef.current.focus())
    }

    function confirm() {
        modalStore.modalData.onChecklistCreated(checklistTitle.trim());
        modalStore.isCreateChecklistDialogOpen = false;
    }


    return (
        <GeneralDialog
            openControl='isCreateChecklistDialogOpen'
            className={`blue-dialog`}
            onEnter={onEnter}
            title={generalStore.translate('createChecklist')}
            body={
                <div>
                    <span className="dialog-description">{generalStore.translate('nameYourChecklist')}</span>
                    <TextField
                        inputRef={inputRef}
                        variant='outlined'
                        placeholder={generalStore.translate('egToDo')}
                        value={checklistTitle}
                        className='name-input'
                        onChange={(e) => setChecklistTitle(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                confirm();
                            }
                        }}
                    />
                </div>
            }
            isConfirmDisabled={!checklistTitle.trim()}
            onConfirm={confirm}
            confirmText={generalStore.translate('create')}
            preserveDataOnClose
        />

    );
});
